export class CreateFleetUserRequest {
    customerId?: string;
    userEmail?: string;
    fleetKind?: string;
    isEnabled?: boolean;
    allowList?: string[];
}